export default __webpack_public_path__ + "static/media/icon-insights-performance-commissions-saved.1660c9b1.svg";